module.exports = __webpack_public_path__ + "cbf41610934614d7aac65d8203330604.svg";